export default function SettingsPage() {
  return <div>Hello settings</div>;
}
